module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    style: ({
      background: this.$store.state.pageBackground
    })
  }, [_c('router-view', {
    staticStyle: {
      "height": "100%"
    }
  }), _vm._v(" "), _c('maintenance-notice')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-724dbdd6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1445
// module chunks = 116